module.exports = __webpack_public_path__ + "img/ios-desktop-guide.eb47a48a.png";